import * as React from "react"

const OtherLayout = ({ children }) => {
  return <div style={{ background: "primary.main" }}>{children}</div>
}

export default OtherLayout
